export default __webpack_public_path__ + "static/media/img11.b2a9e541.PNG";